import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconPlusStyle0 = gravityIconIndividualCss;

const GravityIconPlus = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4cb46dfe9716e1bda57cd8c2999a7085ca0300c9', color: this.color, size: this.size }, h("svg", { key: 'a70821086ad0a111cb62f7975077a941265e6802', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '7685f35bde8701bf13b6cdc0777d955dc3840421', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17 10.25h-5.25V5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v5.25H5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5.25V17a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5.25H17a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5Z", fill: "currentColor" }))));
    }
};
GravityIconPlus.style = GravityIconPlusStyle0;

export { GravityIconPlus as gravity_icon_plus };

//# sourceMappingURL=gravity-icon-plus.entry.js.map